module.exports = __webpack_public_path__ + "static/media/cloud-upload.d71e42a4.gif";